import { Injectable, Injector } from '@angular/core';
import { BaseState } from 'src/app/common/base/base.state'; import { Action, Selector, State, StateContext } from '@ngxs/store';
import { ReviewBoardTypesCreate, ReviewBoardTypesDelete, ReviewBoardTypesRefresh, ReviewBoardTypesUpdate } from './review-board-types.action';
import { ReviewsService } from '../../reviews.service';
import { ReviewBoardType } from '../../reviews.models';

export class ReviewBoardTypesStateModel {
  data: ReviewBoardType[] = [];
}

@State<ReviewBoardTypesStateModel>({
  name: 'ReviewBoardTypes',
  defaults: {
    data: []
  }
})
@Injectable()
export class ReviewBoardTypesState extends BaseState {
  constructor(
    protected override injector: Injector,
    private _service: ReviewsService

  ) {
    super(injector);
  }

  @Selector()
  static read(state: ReviewBoardTypesStateModel) {
    return state.data;
  }

  @Action(ReviewBoardTypesRefresh)
  refresh({ patchState }: StateContext<ReviewBoardTypesStateModel>) {
    this._service.getReviewBoardTypes().subscribe(
      data => patchState({ data }),
      error => console.error(error)
    );
  }

  @Action(ReviewBoardTypesCreate)
  create({ getState, patchState }: StateContext<ReviewBoardTypesStateModel>, { item }: ReviewBoardTypesCreate) {
    const state = getState();
    const index = state.data.map(x => x.id).indexOf(item.id);
    if (index >= 0) {
      state.data.splice(index, 1);
    }
    patchState({
      data: [...getState().data, item]
    });
  }

  @Action(ReviewBoardTypesUpdate)
  update({ getState, patchState }: StateContext<ReviewBoardTypesStateModel>, { id, item }: ReviewBoardTypesUpdate) {
    const state = getState();
    const index = state.data.map(x => x.id).indexOf(id);

    if (index >= 0) {
      state.data.splice(index, 1);
      patchState({
        data: [...state.data, item]
      });
    }
  }

  @Action(ReviewBoardTypesDelete)
  delete({ getState, patchState }: StateContext<ReviewBoardTypesStateModel>, { id }: ReviewBoardTypesDelete) {
    patchState({
      data: getState().data.filter(x => x.id !== id)
    });
  }

}
